function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.8 2.1A1 1 0 0 0 21 .5H2.981a1 1 0 0 0-.8 1.6l7.808 10.491V22.5a1 1 0 0 0 1.6.8l2-1.5a1 1 0 0 0 .4-.8v-8.41z",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgFilter1 = function SvgFilter1(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgFilter1;